import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output,signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InfoBannerService } from './service/info-banner.service';
import { RestaurantInfo } from './interface/info-banner.interface';
import { LoadImagesService } from '../../../../core/service/load-image.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { IsOpen } from '../../../../shared/directives/isOpen';

@Component({
  selector: 'establishment-main-info-banner',
  imports: [CommonModule, NgxSkeletonLoaderModule, IsOpen],
  templateUrl: './info-banner.component.html',
  styleUrl: './info-banner.component.css'
})
export class InfoBannerComponent implements OnInit {
  restaurantInfo: RestaurantInfo | undefined;

  error: string | null = null;
  isOpen = signal(false);
  loading: boolean = true;
  @Output() isclose = new EventEmitter<boolean>();

  constructor(
    private route: ActivatedRoute,
    private infoBannerService: InfoBannerService,
    private loadImageService: LoadImagesService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const id = params['id'];
      // console.log('InfoBannerComponent - ID del restaurante:', id);
      if (id) {
        this.loadRestaurantInfo(id);
      }
    });
  }

  loadRestaurantInfo(id: string): void {
    this.loading = true;
    this.infoBannerService.getInfoEstablishment(id).subscribe({
      next: (response) => {
        this.restaurantInfo = response.data;
        if (this.restaurantInfo) {
          this.isOpen.set(this.infoBannerService.isEstablishmentOpen(
            this.restaurantInfo.apertura,
            this.restaurantInfo.cierre,
            this.restaurantInfo.isOpen
          ));
          this.isClosed(this.isOpen());

        }

        this.loading = false;
      },
      error: (err) => {
        this.error = 'Error loading restaurant information';
        this.loading = false;
        console.error('Error fetching restaurant info:', err);
      }
    });
  }

  getImageUrl(imagePath: string, useBannerDefault?: string): string {
    const defaultImage = 'assets/imagen_default.png';
    const defaultBanner = 'assets/banneer/banner.png';

    if (useBannerDefault && !imagePath) {
      return defaultBanner;
    }

    if (!imagePath) {
      return defaultImage;
    }

    if (imagePath.startsWith('http') || imagePath.startsWith('assets/')) {
      return imagePath;
    }

    return this.loadImageService.linkImage + imagePath;
  }

  onImageError(event: any): void {
    event.target.src = 'assets/imagen_default.png';
  }
  onBannerError(): string {
   return  'assets/banneer/banner.png';
  }

  isClosed(isOpen: boolean): void {
    this.isclose.emit(isOpen);
  }
}


